/**
 * Quick chat tickets API – list and create chats with quick-chat-enabled users.
 */

import { getApiUrl } from "./client";
import { toUserMessage } from "../utils/userMessage";

export async function fetchQuickChatTickets(targetRemoteId) {
  const res = await fetch(getApiUrl(`/quick-chat/users/${encodeURIComponent(targetRemoteId)}/tickets`), {
    method: "GET",
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(toUserMessage(data?.message, "خطا در دریافت گفت‌وگوها"));
  }
  if (data?.status !== "OK" || !Array.isArray(data?.data)) {
    throw new Error(toUserMessage(data?.message, "خطا در دریافت گفت‌وگوها"));
  }
  return data.data;
}

export async function createQuickChatTicket(targetRemoteId) {
  const res = await fetch(getApiUrl(`/quick-chat/users/${encodeURIComponent(targetRemoteId)}/tickets`), {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(toUserMessage(data?.message, "خطا در ایجاد گفت‌وگو"));
  }
  const ticketId = data?.data?.ticket_id;
  if (data?.status !== "OK" || ticketId == null) {
    throw new Error(toUserMessage(data?.message, "خطا در ایجاد گفت‌وگو"));
  }
  return { ticket_id: ticketId };
}
